const STORAGE_KEY = "moji_dark_mode";

export function isDarkMode() {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function setDarkMode(enabled) {
  localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
  applyDarkMode(enabled);
}

export function applyDarkMode(enabled) {
  if (enabled) {
    document.documentElement.setAttribute("data-theme", "dark");
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

export function initDarkMode() {
  const enabled = isDarkMode();
  applyDarkMode(enabled);
  return enabled;
}
